<template>
  <md-dialog
    :id="refName"
    :ref="refName"
    :md-esc-to-close="false"
    :md-click-outside-to-close="false"
    :class="size"
    class="neutral standard-modal"
  >
    <md-dialog-title>
      <div
        class="standard-modal__title"
        :class="{'clickable': headerClickable}"
        @click="headerAction"
      >
        <md-icon
          v-if="iconEnabled"
          :md-src="icons[iconType]"
        />
        {{ title }}
      </div>
      <button
        v-if="closeButtonEnabled"
        class="close-button btn-transparent"
        @click="close()"
      >
        <md-icon>clear</md-icon>
      </button>
    </md-dialog-title>

    <md-dialog-content>
      <div>
        <slot />
      </div>

      <attention-box
        v-if="warningEnabled"
        width="full-size"
      >
        <span v-html="warningText" />
        <span
          v-if="warningAction"
          class="hyper-link"
          @click="warningEvent()"
        >{{ warningAction }}</span>.
      </attention-box>
    </md-dialog-content>
  </md-dialog>
</template>

<script>
import mixin from './../modalMixin'

export default {
  name: 'ModalNeutral',
  mixins: [mixin]
}
</script>

<style lang="scss">
.neutral {
  .close-button {
    position: absolute;
    top: 23px;
    right: 38px;
    z-index: 10;
  }

  .clickable {
    cursor: pointer;
  }
}
</style>
